import { request } from "@/utils/request";
import useSWR from "swr";

interface ResponseMiniApp {
  data: {
    total_actions: number;
    total_users: number;
  };
}

async function fetchMiniApp(url: string) {
  const response = await request(url);
  const data = await response.json();
  return data as ResponseMiniApp;
}

export function useMiniApp() {
  const data = useSWR("/stats/miniapp", fetchMiniApp, {
    refreshInterval: 15_000,
    errorRetryInterval: 10_000,
  });

  return data;
}
